import { REPORT_SOURCE_MODULES, getSourceModuleForReportType } from "./reportTypes";

export function canAccessReports(auth) {
  if (!auth || !auth.isAuthenticated || !auth.currentAreaId) return false;
  if (auth.user && auth.user.is_superadmin) return true;
  return Boolean(auth.currentAreaModules && auth.currentAreaModules.reports);
}

export function canAccessReportSource(auth, sourceModule) {
  if (!auth || !auth.isAuthenticated || !auth.currentAreaId) return false;
  if (auth.user && auth.user.is_superadmin) return true;
  switch (sourceModule) {
    case REPORT_SOURCE_MODULES.APP:
      return true;
    case REPORT_SOURCE_MODULES.TSUNAMI:
      return Boolean(auth.canAccessTsunami);
    case REPORT_SOURCE_MODULES.LANDMARKS:
      return Boolean(auth.canAccessLandmarks);
    default:
      return false;
  }
}

export function validateReportItemAccess(item, auth) {
  if (!canAccessReports(auth)) {
    return { ok: false, reason: "Modul Reporty není pro tento účet povolený." };
  }
  const currentAreaId = auth && auth.currentAreaId != null ? String(auth.currentAreaId) : "";
  const itemAreaId = item && item.areaId != null ? String(item.areaId) : "";
  if (!currentAreaId || !itemAreaId || currentAreaId !== itemAreaId) {
    return { ok: false, reason: "Položka patří k jiné oblasti." };
  }
  const sourceModule = item.sourceModule || getSourceModuleForReportType(item.type);
  if (!canAccessReportSource(auth, sourceModule)) {
    return { ok: false, reason: "Zdrojový modul už není pro tento účet dostupný." };
  }
  return { ok: true, reason: "" };
}
